import { render, staticRenderFns } from "./freedelivery.vue?vue&type=template&id=0f54335b&"
import script from "./freedelivery.vue?vue&type=script&lang=js&"
export * from "./freedelivery.vue?vue&type=script&lang=js&"
import style0 from "./freedelivery.vue?vue&type=style&index=0&id=0f54335b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports